import React from 'react'
import { Icon } from '~/types'
import { AtSymbol, Check, Cube, Document, Folder, Hashtag } from '~/components/icons'

export const getInputIcon = (type: string | undefined): React.ReactNode => {
  const props: Icon.Props = { mode: 'dark', filled: false }

  if (!type) {
    return <AtSymbol {...props} />
  }

  type = type.toLowerCase()

  if (type.includes('boolean')) {
    return <Check {...props} />
  }

  if (type.includes('file') || type.includes('path')) {
    return <Document {...props} />
  }

  if (type.includes('folder')) {
    return <Folder {...props} />
  }

  if (type.includes('integer') || type.includes('number')) {
    return <Hashtag {...props} />
  }

  if (type.includes('array') || type.includes('json')) {
    return <Cube {...props} />
  }

  if (type.includes('string')) {
    return <AtSymbol {...props} />
  }

  return <AtSymbol {...props} />
}
